import GS from '../../grafsync/grafsync';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Loading from '../Loading';
import { globalStyles } from '../style/gstheme';
import { makeCancelable, sortObjects } from '../utils/utils';
import TemplateBox from './TemplateBox';

const styles = theme => {
    return Object.assign({
        box: {
            display: 'inline-block',
            marginRight: 40
        },
        defaultThumbnail: {
            boxShadow: '0px 1px 3px #00000029',
            width: 302,
            height: 170,
            borderRadius: 4,
            padding: 6,
            marginBottom: 12,
            '&:hover': {
                cursor: 'pointer',
                boxShadow: '0px 12px 17px #00000033'
            }
        },
        innerDefault: {
            borderRadius: 4,
            height: 130,
            marginBottom: 10,
            textAlign: 'center',
            border: 'solid 1px #97d700'
        },
        thumbnailHeading: {
            marginLeft: 12
        },
        thumbnailButton: {
            width: 24,
            height: 24,
            color: '#97d700',
            marginTop: 55
        },
        headerText: {
            fontSize: 10,
            fill: '#000000',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, globalStyles);
};

class TemplateSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            templates: [],
            isLoading: true,
            isErrored: null
        };
        this.cancellable = null;
    }

    componentDidMount() {
        this.doSearch(
            {
                search: [
                    {
                        predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                        value: "https://grafsync.graphifi.com/schema/tsv/TsvTemplate"
                    },
                    {
                        predicate: "https://grafsync.graphifi.com/schema/tsv/templateTarget",
                        value: this.props.id
                    }
                ],
                sort: ["http://purl.org/dc/terms/title"],
                page: 1,
                graph: [this.props.graph],
                noCount: true,
                pageSize: 200
            }
        ).promise
            .then(data => {
                const templates = data.results ? sortObjects([...data.results], 'title') : null;
                this.setState({ templates, isLoading: false });
                // Load all the templates here
            })
            .catch((e) => {
                if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
            });
    }

    doSearch(payload) {
        this.cancellable = makeCancelable(GS.search(payload));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    deleteTemplate = (id) => {
        GS.deleteResource(id, this.props.graph);
    }

    render() {

        const { classes, defaultLang, onSelect, graph } = this.props;
        const { isLoading, templates } = this.state;

        if (isLoading) return <Loading />;

        return (
            <div>
                <Typography paragraph className={classes.mainHeading}>Select a TSV Template</Typography>
                <div data-test="tsv-template-list">
                    <div data-test="blank-tsv-template" className={classes.box} onClick={() => onSelect({
                        type: "TsvTemplate"
                    }, templates.length < 29)}>
                        <div className={classes.defaultThumbnail}>
                            <div className={classes.innerDefault}>
                                <AddCircleIcon className={classes.thumbnailButton} />
                            </div>
                            <div className={classes.thumbnailHeading}>
                                <Typography paragraph variant="body2">Blank Template</Typography>
                            </div>
                        </div>
                    </div>
                    {templates.map((template) => <div key={template.id} className={classes.box}>
                        <TemplateBox
                            id={template.id}
                            graph={graph}
                            onRename={this.renameTemplate}
                            onDelete={this.deleteTemplate}
                            onSelect={() => onSelect(template, templates.length < 29)}
                            defaultLang={defaultLang} />
                    </div>
                    )}
                </div>
            </div>
        );
    }
}

TemplateSelector.propTypes = {
    onSelect: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(TemplateSelector);